/* Back and next buttons side by side in a curved notch for a slider-component. The back button is hidden on the first slide;
   the next button is disabled on the last. */
if (!customElements.get('slider-notches')) {
  customElements.define(
    'slider-notches',
    class SliderNotches extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('slider-component');
        this.notch = this.querySelector('.slider-notches__notch');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');

        // A slider with a single slide never builds Flickity, so its notch stays hidden.
        if (this.slider.flkty) this.bind();
        else this.addEventListener('theme:slider:loaded', () => this.bind(), { once: true });
      }

      bind() {
        const flkty = this.slider.flkty;
        // Like Flickity's own controls, a click stops autoplay for good.
        this.prevButton.addEventListener('click', () => {
          flkty.stopPlayer();
          flkty.previous();
        });
        this.nextButton.addEventListener('click', () => {
          flkty.stopPlayer();
          flkty.next();
        });

        const update = () => {
          const first = flkty.selectedIndex === 0;
          this.classList.toggle('is-first', first);
          this.prevButton.inert = first;
          this.nextButton.disabled = flkty.selectedIndex === flkty.slides.length - 1;
        };
        flkty.on('select', update);
        update();
        this.notch.classList.add('is-shown');
      }
    }
  );
}
